// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.address-component {
  min-height: 100vh;
  margin-bottom: 4rem;
}

.address-subtitle-box {
  margin: 2rem 0 0 0;
}

.address-searchtitle-box {
  margin: 0 0 1rem 0;
}

.address-form-box {
  margin: 0 0 4rem 0;
}

.address-history-box {
  margin: 0 0 4rem 0;
}

.form-field {
  width: 100%;
}

.table-box {
  display: flex;
  flex-direction: column;
  max-height: 550px;
  min-width: 100%;
}

.mat-table {
  overflow: auto;
  max-height: 550px;
}

.mobile-label {
  display: none;
}

button {
  outline: none;
}

.button-right {
  margin-left: 1rem;
}

@media (max-width: 1400px) {
  .mobile-label {
    width: 85px;
    display: inline-block;
    font-weight: bold;
  }
  .mat-header-row {
    display: none;
  }
  .mat-row {
    flex-direction: column;
    align-items: start;
    max-height: 450px;
  }
  .mat-cell {
    padding-left: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./projects/zbs-app/src/app/modules/customer/components/customer-search/customer-search.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;AACJ;;AAEA;EACI,cAAA;EACA,iBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI;IACI,WAAA;IACA,qBAAA;IACA,iBAAA;EACN;EAEE;IACI,aAAA;EAAN;EAGE;IACI,sBAAA;IACA,kBAAA;IACA,iBAAA;EADN;EAIE;IACI,kBAAA;EAFN;AACF","sourcesContent":[".address-component {\r\n    min-height: 100vh;\r\n    margin-bottom: 4rem;\r\n}\r\n\r\n.address-subtitle-box {\r\n    margin: 2rem 0 0 0;\r\n}\r\n\r\n.address-searchtitle-box {\r\n    margin: 0 0 1rem 0;\r\n}\r\n\r\n.address-form-box {\r\n    margin: 0 0 4rem 0;\r\n}\r\n\r\n.address-history-box {\r\n    margin: 0 0 4rem 0;\r\n}\r\n\r\n.form-field {\r\n    width: 100%;\r\n}\r\n\r\n.table-box {\r\n    display: flex;\r\n    flex-direction: column;\r\n    max-height: 550px;\r\n    min-width: 100%;\r\n}\r\n\r\n.mat-table {\r\n    overflow: auto;\r\n    max-height: 550px;\r\n}\r\n\r\n.mobile-label {\r\n    display: none;\r\n}\r\n\r\nbutton {\r\n    outline: none;\r\n}\r\n\r\n.button-right {\r\n    margin-left: 1rem;\r\n}\r\n\r\n@media(max-width: 1400px) {\r\n    .mobile-label {\r\n        width: 85px;\r\n        display: inline-block;\r\n        font-weight: bold;\r\n    }\r\n\r\n    .mat-header-row {\r\n        display: none;\r\n    }\r\n\r\n    .mat-row {\r\n        flex-direction: column;\r\n        align-items: start;\r\n        max-height: 450px;\r\n    }\r\n\r\n    .mat-cell {\r\n        padding-left: 1rem;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
